/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Construction sign by koen caspers [CC-BY] (https://creativecommons.org/licenses/by/3.0/) via Poly Pizza (https://poly.pizza/m/4v9QhryzBwT)
*/
import { Center, useGLTF, useMatcapTexture } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { useEffect, useState, type JSX } from 'react'
import { MeshMatcapMaterial, type Material, type Mesh, type MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      mesh1969675137: Mesh
      mesh1969675137_1: Mesh
      mesh1969675137_2: Mesh
      group1176710984: Mesh
      group790830455: Mesh
      mesh1899794681: Mesh
      mesh1899794681_1: Mesh
      mesh1899794681_2: Mesh
      group56958267: Mesh
      group2019904400: Mesh
      mesh1273453722: Mesh
      mesh1273453722_1: Mesh
      mesh1273453722_2: Mesh
      mesh1038710627: Mesh
      mesh1038710627_1: Mesh
      mesh1038710627_2: Mesh
    }
    materials: {
      mat21: MeshStandardMaterial
      mat23: MeshStandardMaterial
      mat12: MeshStandardMaterial
    }
  }

export function Sign(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/sign.glb') as GLTFResult

  const [matcap] = useMatcapTexture('7A7A7A_D9D9D9_BCBCBC_B4B4B4', 64)
  const [overriddenMaterials, setOverriddenMaterials] = useState<Record<string, Material>>()

  useEffect(() => {
    setOverriddenMaterials({
      mat21: new MeshMatcapMaterial({ matcap, color: materials.mat21.color }),
      mat23: new MeshMatcapMaterial({ matcap, color: materials.mat23.color }),
      mat12: new MeshMatcapMaterial({ matcap, color: materials.mat12.color }),
    })
  }, [materials, matcap])

  return (
    overriddenMaterials && (
      <group {...props} dispose={null}>
        <Center position-y={0.7}>
          <group>
            <mesh geometry={nodes.mesh1969675137.geometry} material={overriddenMaterials.mat21} />
            <mesh geometry={nodes.mesh1969675137_1.geometry} material={overriddenMaterials.mat23} />
            <mesh geometry={nodes.mesh1969675137_2.geometry} material={overriddenMaterials.mat12} />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.group1176710984.geometry}
            material={overriddenMaterials.mat21}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.group790830455.geometry}
            material={overriddenMaterials.mat21}
          />
          <group>
            <mesh geometry={nodes.mesh1899794681.geometry} material={overriddenMaterials.mat21} />
            <mesh geometry={nodes.mesh1899794681_1.geometry} material={overriddenMaterials.mat23} />
            <mesh geometry={nodes.mesh1899794681_2.geometry} material={overriddenMaterials.mat12} />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.group56958267.geometry}
            material={overriddenMaterials.mat21}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.group2019904400.geometry}
            material={overriddenMaterials.mat21}
          />
          <group>
            <mesh geometry={nodes.mesh1273453722.geometry} material={overriddenMaterials.mat21} />
            <mesh geometry={nodes.mesh1273453722_1.geometry} material={overriddenMaterials.mat23} />
            <mesh geometry={nodes.mesh1273453722_2.geometry} material={overriddenMaterials.mat12} />
          </group>
          <group>
            <mesh geometry={nodes.mesh1038710627.geometry} material={overriddenMaterials.mat12} />
            <mesh geometry={nodes.mesh1038710627_1.geometry} material={overriddenMaterials.mat21} />
            <mesh geometry={nodes.mesh1038710627_2.geometry} material={overriddenMaterials.mat23} />
          </group>
        </Center>
      </group>
    )
  )
}

useGLTF.preload('/models/sign.glb')
